import { Suspense, lazy } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { icons as lizzyIcons } from 'components/icons';
import styled from 'styled-components';

export const SOURCES = {
  MATERIAL: 'material',
  LIZZY: 'lizzy',
  FEATHER: 'feather'
};

const Icon = ({ source, name, className, options, ...props }) => {
  if (source === SOURCES.MATERIAL) {
    return (
      <MaterialIcon
        options={options}
        className={classNames(className, 'material-symbols-rounded')}
        {...props}
      >
        {name}
      </MaterialIcon>
    );
  }

  if (source === SOURCES.FEATHER) {
    const FeatherIcon = lazy(() => import(`react-feather/dist/icons/${name}`));

    return (
      <Suspense fallback={<i />}>
        <FeatherIcon className={classNames(className, 'feather-icon')} {...props} />
      </Suspense>
    );
  }

  if (source === SOURCES.LIZZY && lizzyIcons[name]) {
    const SVGIcon = lizzyIcons[name];

    return (
      <Suspense fallback={<i />}>
        <LizzyIcon>
          <SVGIcon className={classNames(className, 'lizzy-icon', name)} />
        </LizzyIcon>
      </Suspense>
    )
  }
}

export default styled(Icon)``;

Icon.propTypes = {
  source: PropTypes.oneOf(Object.values(SOURCES)),
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  options: PropTypes.shape(PropTypes.any),
};

Icon.defaultProps = {
  source: SOURCES.LIZZY
}

const MaterialIcon = styled.i`
  font-variation-settings:
    'FILL' ${p => (p.options && p.options['FILL']) || 0},
    'wght' ${p => (p.options && p.options['wght']) || 400},
    'GRAD' ${p => (p.options && p.options['GRAD']) || 0},
    'opsz' ${p => (p.options && p.options['opsz']) || 40};
`;

const LizzyIcon = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;

  .lizzy-icon {

  }
`;